import React from 'react';
import { Button, message } from 'antd';
import IssueActionsView from './IssuesActionsView';
import RequestsActionsView from './RequestsActionsView';
import CheckInsActionView from './CheckInsActionView';
import ReportsActionView from './ReportsActionView';
import WikiActionView from './WikiActionView';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { getSkillUser } from '../../../../../components/skills/skills_action';
import { useEffect } from 'react';
const ManageActions = (props) => {
  const { pageView, apphome, hideCustomizeButtons } = props;
  const skills = useSelector((state) => state.skills.skills);
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const dispatch = useDispatch();
  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  const isPersonalApphome = props.isPersonalApphome ? true : false;
  const handleCustomizeButtons = async () => {
    try {
      const jiraSkill = skills.find((skill) => skill.key === 'jira');
      const currentSkillUser = await dispatch(
        getSkillUser(props.match.params.wId, jiraSkill.skill_metadata._id)
      );
      if (!jiraSkill.skill_metadata.linked) {
        return message.error({
          content: (
            <>
              Jira is not connected. Click
              <a
                onClick={() => {
                  props.history.push(
                    `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=connection`
                  );
                }}
              >
                {' '}
                here{' '}
              </a>
              to connect to your Jira.
            </>
          ),
          onClick: () => message.destroy(),
        });
      }
      let isUserVerified = false;

      if (currentSkillUser && currentSkillUser.data.skillUser.token_obj) {
        isUserVerified = true;
      }
      if (!isUserVerified) {
        return message.error({
          content: (
            <>
              Verify your personal Jira connection. Click
              <a
                onClick={() => {
                  props.history.push(
                    `/${props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=personal_preferences`
                  );
                }}
              >
                {' '}
                here{' '}
              </a>
              to verify.
            </>
          ),
          onClick: () => message.destroy(),
        });
      }

      if (isPersonalApphome) {
        props.history.push(
          `/${props.match.params.wId}/settings/personalapphome/customize?view=buttonList&pageView=${pageViewType}`
        );
      } else {
        props.history.push(
          `/${props.match.params.wId}/slackApp/apphome?view=buttonList&pageView=${pageViewType}`
        );
      }
    } catch (error) {}
  };
  return (
    <>
      {pageViewType === 'approvals' ? (
        ''
      ) : (
        <div style={{ paddingTop: '24px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingBottom: '8px',
            }}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '12.5px',
              }}
            >
              My Actions
            </div>
            {(pageViewType === 'issues' || pageViewType === 'requests') && (
              <div>
                <Button
                  disabled={hideCustomizeButtons}
                  className='apphome_primary_buttons'
                  type='primary'
                  onClick={handleCustomizeButtons}
                >
                  <div>Customize buttons</div>
                </Button>
              </div>
            )}
          </div>
          <div
            style={{
              borderBottom: `${
                isDarkTheme
                  ? '1px solid rgba(255, 255, 255, 0.1)'
                  : '1px solid rgba(0, 0, 0, 0.06)'
              }`,
            }}
            className='apphome_borders'
          ></div>
          <div style={{ paddingTop: '16px' }}>
            {pageViewType === 'issues' && (
              <IssueActionsView apphome={apphome} />
            )}
            {pageViewType === 'requests' && (
              <RequestsActionsView apphome={apphome} />
            )}
            {pageViewType === 'checkins' && (
              <CheckInsActionView apphome={apphome} />
            )}
            {pageViewType === 'reports' && (
              <ReportsActionView apphome={apphome} />
            )}
            {pageViewType === 'wiki' && <WikiActionView apphome={apphome} />}
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(ManageActions);
